// src/components/Dashboard/KPICards.jsx
import React from 'react';
import { CurrencyDollarIcon, DocumentTextIcon, UsersIcon, CubeIcon } from '@heroicons/react/24/outline';

export default function KPICards({ data }) {
  const cards = [
    {
      title: 'Today\'s Sales',
      value: `KES ${data?.todaySales?.toLocaleString() || 0}`,
      icon: CurrencyDollarIcon,
      color: 'bg-blue-500',
      change: '+%',
    },
    {
      title: 'Transactions',
      value: data?.todayTransactions || 0,
      icon: DocumentTextIcon,
      color: 'bg-green-500',
      change: '+%',
    },
    {
      title: 'Customers',
      value: data?.totalCustomers || 0,
      icon: UsersIcon,
      color: 'bg-purple-500',
      change: '+%',
    },
    {
      title: 'Low Stock Items',
      value: data?.lowStockItems || 0,
      icon: CubeIcon,
      color: 'bg-red-500',
      change: '-%',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <div key={index} className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-500">{card.title}</p>
              <p className="text-2xl font-bold mt-1">{card.value}</p>
              {card.change && (
                <p className={`text-xs mt-1 ${card.change.startsWith('+') ? 'text-green-600' : 'text-red-600'}`}>
                  {card.change} from yesterday
                </p>
              )}
            </div>
            <div className={`${card.color} p-3 rounded-full`}>
              <card.icon className="h-6 w-6 text-white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}